// extracted by css-extract-rspack-plugin
export default {"root":"root-xZ8hgX","wrapper":"wrapper-G9RQFd","form":"form-_ji_9D","title":"title-tK4Pl9","lead":"lead-EXu7Bb"};